import menuApi from './menu.service'
import { getActiveClientId } from '../clients/selectors'
import { RootState } from '../store'
import reducer from '.'

export const getMenu = (state: RootState) => {
  const id = getActiveClientId(state)
  return menuApi.endpoints.getMenu.select(id)(state)
}

export const getMenuStates = (state: RootState) => state[reducer.name]
